import React, { lazy, Suspense } from 'react'

const Lazy = lazy(() => import('./sync').catch((error) => {
    console.log('[APP] Component Failed Loading:', error)
    return { default: () => null }
}))

export default (props) => {
    return (
        <Suspense fallback={null}>
            <Lazy {...props} />
        </Suspense>
    )
}
